var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.48 25c1.08 0 1.96-.82 1.96-1.84 0-1.01-.88-1.84-1.96-1.84-1.07 0-1.95.83-1.95 1.84 0 1.02.88 1.84 1.95 1.84zM8.2 25c1.08 0 1.96-.82 1.96-1.84 0-1.01-.88-1.84-1.96-1.84s-1.95.83-1.95 1.84c0 1.02.87 1.84 1.95 1.84zM5.91 8.82L3.57 5.15H0v1.47h2.68l2 3.14v4.95H25V8.82H5.91zM15.63 21.32H25v-5.14h-9.38v5.14zM4.69 21.32h9.37v-5.14H4.7v5.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.63 2.98v-1.5h1.56V0H12.5v1.47h1.56v1.51a6.98 6.98 0 00-5.85 4.37h13.26a6.98 6.98 0 00-5.84-4.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequests);
export default ForwardRef;